import { store } from 'app/redux/store';
import { BusinessProjectGetId } from 'app/services/responseTypes';
import {
  updateFieldArrayKey,
  updateKey,
} from '../edit/TaxQuestionnaire/BusinessInfo/GeneralInfo/slice';

const capitalizeFirstLetter = (str: string | null | undefined) =>
  str ? str.charAt(0).toUpperCase() + str.slice(1) : '';

export default function autoFillBusinessGeneralInfoSlice(
  business: BusinessProjectGetId,
) {
  const {
    name,
    address,
    city,
    state,
    zipcode,
    formation_date,
    ownership,
    ein,
    formation_state,
  } = business;

  store.dispatch(updateKey({ key: 'businessName', value: name ?? '' }));
  store.dispatch(updateKey({ key: 'businessAddress', value: address ?? '' }));
  store.dispatch(
    updateKey({ key: 'employerIdentificationNumber', value: ein ?? '' }),
  );
  store.dispatch(
    updateKey({
      key: 'inWhatStateDidYouRegisterYourBusiness',
      value: formation_state ?? '',
    }),
  );
  store.dispatch(updateKey({ key: 'city', value: city ?? '' }));
  store.dispatch(updateKey({ key: 'state', value: state ?? '' }));
  store.dispatch(updateKey({ key: 'zipCode', value: zipcode ?? '' }));
  store.dispatch(
    updateKey({ key: 'dateBusinessWasFormed', value: formation_date ?? '' }),
  );
  store.dispatch(
    updateKey({
      key: 'thisEntityIsOwnedByAn',
      value: capitalizeFirstLetter(ownership),
    }),
  );
}
